module.exports = __webpack_public_path__ + "img/lever09.c81d5758.png";